// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gcy7","colMin":"styles_colMin__2tozW"};